"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCrossReferenceSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ProductCrossReferenceSearchResponse extends common_1.PaginatedResponse {
}
exports.ProductCrossReferenceSearchResponse = ProductCrossReferenceSearchResponse;
//# sourceMappingURL=product-cross-reference-search.response.js.map